define(function (require) {
    var ko = require("knockout");
    var _ = require("underscore");
    var querystring = require("querystring");

    // ctor for PharmacyResultViewModel
    return function (parent, data, lat, lng, year, radius) {
        var self = this;

        self.providerId = ko.observable(data.ProviderId);
        self.name = ko.observable(data.Name);
        self.phone = ko.observable(data.Phone);
        self.address1 = ko.observable(data.Address1);
        self.address2 = ko.observable(data.Address2);
        self.city = ko.observable(data.City);
        self.state = ko.observable(data.State);
        self.zip = ko.observable(data.Zip);
        self.distance = ko.observable(data.Distance);
        self.hasDelivery = ko.observable(data.ProvidesDeliveryService);
        self.hasDriveThrough = ko.observable(data.HasDriveThrough);
        self.pharmacyTypes = ko.observableArray(data.PharmacyTypes);
        self.spokenLanguages = ko.observableArray(data.SpokenLanguages);
        self.preferred = ko.observable(data.Preferred);
        self.open24Hours = ko.observable(data.Open24Hours);
        self.ninetyDaySupplyAvailable = ko.observable(data.NinetyDaySupply);
        self.ePrescribingAvailable = ko.observable(data.ElectronicPrescriptions);
        self.types = ko.observableArray(data.PharmacyTypes);

        self.telHref = ko.computed(function () {
            return self.phone() ? "tel:" + self.phone().replace(/[^\d]/g, "") : null;
        });

        self.mapUrl = ko.computed(function () {
            var segments = [self.address1(), self.address2(), self.city(), self.state(), self.zip()];

            var search = _.chain(segments).compact().value().join(",");

            return "https://www.google.com/maps/search/" + encodeURIComponent(search);
        });

        self.detailUrl = ko.computed(function () {
            var query = {
                providerId: self.providerId(),
                latitude: lat,
                longitude: lng
            };

            if (year) {
                query.year = year;
            }

            return window.scan.toolDetailUrl + "?" + querystring.stringify(query);
        });

        self.viewDetails = function () {
            parent.viewDetails(self.providerId(), lat, lng);
        };
    };
});
